import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img5 from '../Assets/video5.png.png'
import img3 from '../Assets/cards.png'
import { Get_Api } from '../Api_Url'
import ContentLoader from 'react-content-loader'
import { useNavigate } from 'react-router-dom'
import GetSeodata from '../Components/GetSeodata'

function Blog() {
        const navigate = useNavigate()
        const [BlogData, setBlogData] = useState([]);
        const [IsUploading, setIsUploading] = useState(false);
        const GetAllBlog = async () => {
                try {
                        setIsUploading(true)
                        const response = await Get_Api(`api/admin/GetAllBlogs`)
                        setBlogData(response?.data)
                        setIsUploading(false)
                } catch (error) {
                        setIsUploading(false)
                        console.log(error)
                }
        }

        useEffect(() => {
                GetAllBlog();
        }, []);

        const Blogdetail = (id) => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate(`/BlogDetils/${id}`)
        }


        return (
                <>
                        <Navbar />
                        <GetSeodata PageName={'blog'} />
                        <div className='about-div'>
                                <h1>Articles</h1>
                                <p><i>Home - Blogs</i></p>
                        </div>
                        <div className='Featuredcustom-blog-card-container'>
                                <div className="custom-blog-container">
                                        {IsUploading ? (
                                                <ContentLoader viewBox="0 0 900 250" height="100%" width="100%">
                                                        <rect x="30" y="20" rx="0" ry="0" width="130" height="23" />
                                                        <rect x="30" y="60" rx="0" ry="0" width="200" height="120" />
                                                        <rect x="30" y="189" rx="0" ry="0" width="200" height="15" />
                                                        <rect x="30" y="211" rx="0" ry="0" width="140" height="15" />
                                                        <rect x="243" y="60" rx="0" ry="0" width="200" height="120" />
                                                        <rect x="243" y="189" rx="0" ry="0" width="200" height="15" />
                                                        <rect x="243" y="211" rx="0" ry="0" width="140" height="15" />
                                                        <rect x="455" y="60" rx="0" ry="0" width="200" height="120" />
                                                        <rect x="455" y="189" rx="0" ry="0" width="200" height="15" />
                                                        <rect x="455" y="211" rx="0" ry="0" width="140" height="15" />
                                                        <rect x="667" y="60" rx="0" ry="0" width="200" height="120" />
                                                        <rect x="667" y="188" rx="0" ry="0" width="200" height="15" />
                                                        <rect x="667" y="209" rx="0" ry="0" width="140" height="15" />
                                                </ContentLoader>
                                        ) : (
                                                <div className="custom-blog-card-container">
                                                        {BlogData?.map((blog, index) => (
                                                                <div
                                                                        key={index}
                                                                        onClick={() => Blogdetail(blog?._id)}
                                                                        className="custom-blog-card"
                                                                >
                                                                        <img src={blog?.Image || img3} alt="Blog" className="custom-blog-card-image" />
                                                                        <div className="custom-blog-card-text">
                                                                                <h2>{blog?.Name}</h2>
                                                                        </div>
                                                                </div>
                                                        ))}
                                                </div>
                                        )}
                                </div>
                        </div>
                        <Footer />
                </>
        )
}

export default Blog